var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._g({staticClass:"zoox-component zoox-avatar",attrs:{"size":_vm.size,"color":_vm.color}},_vm.$listeners),[(_vm.photo)?_c('img',_vm._b({attrs:{"src":_vm.photo,"alt":_vm.name}},'img',_vm.$attrs,false)):_c('span',_vm._b({staticClass:"avatar"},'span',_vm.$attrs,false),[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }